import React from 'react';
import { useFormik } from 'formik';
import { makeStyles } from '@material-ui/core';
import { loginFormValidationSchema } from './loginFormValidationSchema';
import {
  BaseButton,
  BaseTypography,
  PasswordTextField,
  BaseTextField,
} from 'src/components/common';
import { ILoginModel } from 'src/api/base/Auth/types';
import { useFormikErrorsHandler } from 'src/utils/hooks/useFormikErrorsHandler';
import { IBaseForm } from 'src/utils/types/forms';

const useStyles = makeStyles((theme) => ({
  formGroup: {
    display: 'grid',
    gridGap: '25px',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: '20px',
  },
  links: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridGap: '10px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      gridAutoFlow: 'row',
    },
  },
}));

export type PLoginForm = IBaseForm<ILoginModel> & {
  onRegisterClick: () => void;
  onForgotPassword: () => void;
};

export const LoginForm: React.FC<PLoginForm> = (props) => {
  const { onSubmit, loading, errors, onRegisterClick, onForgotPassword } =
    props;
  const classes = useStyles();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginFormValidationSchema,
    validateOnChange: false,
    onSubmit: (values) => {
      onSubmit(values);
      formik.setErrors({});
    },
  });

  useFormikErrorsHandler({ errors, setFieldError: formik.setFieldError });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className={classes.formGroup}>
          <div className={classes.formRow}>
            <BaseTextField
              label="Email"
              value={formik.values.email}
              name="email"
              onChange={formik.handleChange}
              errorText={formik.errors.email}
              placeholder="example@mail.com"
            />
            <PasswordTextField
              label="Password"
              value={formik.values.password}
              name="password"
              onChange={formik.handleChange}
              errorText={formik.errors.password}
              placeholder="************"
            />
            <BaseButton variant="contained" loading={loading} type="submit">
              Login
            </BaseButton>
          </div>

          <div className={classes.links}>
            <BaseTypography
              variant="smallText"
              onClick={onForgotPassword}
              className="pointer"
            >
              <span className="primary">Forgot password</span>
            </BaseTypography>
            <BaseTypography variant="smallText" onClick={onRegisterClick}>
              Looking to
              <span className="primary pointer"> create an account</span>?
            </BaseTypography>
          </div>
        </div>
      </form>
    </div>
  );
};
